<template>
  <div class="flex flex-col gap-3">
    <h2 class="font-semibold text-base text-gray-700 px-1">{{ title }}</h2>
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{ title: string }>();
</script>
